import { components, CountryIsoCode } from 'shared/data/walletsKyc/v1';

export const buildCompanyAddressesInitialValues = (
    businessInformation: components['schemas']['FormBusinessInformationAnswer'] | undefined
) => ({
    areCompanyAddressesEqual:
        typeof businessInformation?.areCompanyAddressesEqual === 'boolean'
            ? businessInformation.areCompanyAddressesEqual
            : true,
    registeredAddress: {
        ...businessInformation?.registeredAddress,
        country: businessInformation?.registeredAddress?.country ?? CountryIsoCode.GB,
    },
    tradingAddress: {
        ...businessInformation?.tradingAddress,
        country: businessInformation?.tradingAddress?.country ?? CountryIsoCode.GB,
    },
});
